import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { AnimatePresence } from 'framer-motion';

import { useAuth } from '../hooks/useAuth';
import {
  CadastrarInstrucoes,
  CadastrarManual,
  CadastrarMensagemCritica,
  CadastrarPerfis,
  CadastrarPerguntas,
  CadastrarTelas,
  Dashboard,
  DashboardConvenios,
  DashboardPagamentos,
  EditarInstrucoes,
  EditarManual,
  EditarMensagemCritica,
  EditarPerfis,
  EditarPerguntas,
  EditarTelas,
  Home,
  ListarInstrucoes,
  ListarManual,
  ListarMensagemCritica,
  ListarPerfis,
  ListarPerguntas,
  ListarTelas,
  Login,
  LoginExterno,
  MotorCobranca,
  MotorConvenios,
  MotorPagamentos,
  Session404,
  SessionExpired,
  SessionUnauthorized,
} from '../pages';
import PrivateRoute from './Route';

const Routes: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  let script = document.createElement('script');
  var chatButton = document.createElement('div');

  if (
    location.pathname === '/motor' ||
    location.pathname === '/motor-pagamentos' ||
    location.pathname === '/motor-convenios'
  ) {
    // Create Ubots Icon
    chatButton.id = 'ubots-webchat-icon';
    chatButton.setAttribute('onclick', 'UbotsWC.openChat()');
    chatButton.style.width = '75px';
    chatButton.style.height = '75px';
    chatButton.style.background = '#166649';
    chatButton.style.borderRadius = '50%';
    chatButton.style.overflow = 'hidden';
    chatButton.style.position = 'fixed';
    chatButton.style.bottom = '2.5rem';
    chatButton.style.right = '3rem';
    chatButton.style.padding = '0.9rem';
    chatButton.style.justifyContent = 'center';
    chatButton.style.alignItems = 'center';
    chatButton.style.cursor = 'pointer';
    // chatButton.style.boxShadow = '0px 4px 8px rgba(0, 0, 0, .2)';
    chatButton.innerHTML =
      "<img style='display: flex; width: 45px; justify-content: center; align-items: center: padding: 2rem' src='assets/icons/ic_chat.svg' alt='' />";
    document.getElementsByTagName('main')[0].appendChild(chatButton);
    // Create Script Ubots
    script.type = 'text/javascript';
    script.id = 'debugScript';
    script.src = `${process.env.PUBLIC_URL}/script/ubots.js`;
    document.getElementsByTagName('body')[0].appendChild(script);
    // Remove Destroy Session
    let destroyScript = document.querySelectorAll('#ubots-destroy-session');
    destroyScript.forEach(e => e.parentNode?.removeChild(e));
  }

  if (
    location.pathname !== '/motor' &&
    location.pathname !== '/motor-pagamentos' &&
    location.pathname !== '/motor-convenios' &&
    location.pathname !== '/login' &&
    script !== null
  ) {
    let destroyScript = document.createElement('script');
    destroyScript.id = 'ubots-destroy-session';
    destroyScript.innerHTML = 'UbotsWC.destroySession();';
    document.getElementsByTagName('body')[0].appendChild(destroyScript);

    let scriptList = document.querySelectorAll('#debugScript');
    let UbotsButtonInit = document.querySelectorAll('#ubots-chat-init');
    let UbotsName = document.querySelectorAll('#ubots-name');
    let UbotsEmail = document.querySelectorAll('#ubots-email');
    let UbotsIcon = document.querySelectorAll('#ubots-webchat-icon');
    let UbotsChat = document.querySelectorAll('#ubots-webchat-div');
    let UbotsForm = document.querySelectorAll('#ubots-form-div');

    scriptList.forEach(e => e.parentNode?.removeChild(e));
    UbotsButtonInit.forEach(e => e.parentNode?.removeChild(e));
    UbotsName.forEach(e => e.parentNode?.removeChild(e));
    UbotsEmail.forEach(e => e.parentNode?.removeChild(e));
    UbotsIcon.forEach(e => e.parentNode?.removeChild(e));
    UbotsChat.forEach(e => e.parentNode?.removeChild(e));
    UbotsForm.forEach(e => e.parentNode?.removeChild(e));
  }

  return (
    <AnimatePresence exitBeforeEnter>
      <Switch location={location} key={location.pathname}>
        <Route exact path="/">
          {isAuthenticated() ? (
            <Redirect to={RoutesPaths.home} />
          ) : (
            <Redirect to={RoutesPaths.login} />
          )}
        </Route>
        <Route path={RoutesPaths.login} exact component={Login} />
        <Route path={RoutesPaths.loginExterno} exact component={LoginExterno} />
        <Route path={'/cooperado'} component={LoginExterno} />
        <PrivateRoute path={RoutesPaths.home} exact component={Home} />
        <PrivateRoute
          path={RoutesPaths.motorCobranca}
          exact
          component={MotorCobranca}
        />
        <PrivateRoute
          path={RoutesPaths.motorPagamentos}
          exact
          component={MotorPagamentos}
        />
        <PrivateRoute
          path={RoutesPaths.motorConvenios}
          exact
          component={MotorConvenios}
        />
        <PrivateRoute
          path={RoutesPaths.registerFAQ}
          exact
          component={CadastrarPerguntas}
        />
        <PrivateRoute
          path={RoutesPaths.listFAQ}
          exact
          component={ListarPerguntas}
        />
        <PrivateRoute
          path={`${RoutesPaths.editFAQ}:id`}
          exact
          component={EditarPerguntas}
        />
        <PrivateRoute
          path={RoutesPaths.dashboardCobranca}
          exact
          component={Dashboard}
        />
        <PrivateRoute
          path={RoutesPaths.dashboardPagamentos}
          exact
          component={DashboardPagamentos}
        />
        <PrivateRoute
          path={RoutesPaths.dashboardConvenios}
          exact
          component={DashboardConvenios}
        />
        <PrivateRoute
          path={RoutesPaths.registerCriticalMessage}
          exact
          component={CadastrarMensagemCritica}
        />
        <PrivateRoute
          path={RoutesPaths.listCriticalMessage}
          exact
          component={ListarMensagemCritica}
        />
        <PrivateRoute
          path={`${RoutesPaths.editCriticalMessage}:id`}
          exact
          component={EditarMensagemCritica}
        />

        <PrivateRoute
          path={RoutesPaths.registerScreen}
          exact
          component={CadastrarTelas}
        />
        <PrivateRoute
          path={RoutesPaths.listScreen}
          exact
          component={ListarTelas}
        />
        <PrivateRoute
          path={`${RoutesPaths.editScreen}:id`}
          exact
          component={EditarTelas}
        />

        <PrivateRoute
          path={RoutesPaths.registerPerfil}
          exact
          component={CadastrarPerfis}
        />
        <PrivateRoute
          path={RoutesPaths.listPerfil}
          exact
          component={ListarPerfis}
        />
        <PrivateRoute
          path={`${RoutesPaths.editPerfil}:id`}
          exact
          component={EditarPerfis}
        />

        <PrivateRoute
          path={RoutesPaths.registerInstruction}
          exact
          component={CadastrarInstrucoes}
        />
        <PrivateRoute
          path={RoutesPaths.listInstruction}
          exact
          component={ListarInstrucoes}
        />
        <PrivateRoute
          path={`${RoutesPaths.editInstruction}:id`}
          exact
          component={EditarInstrucoes}
        />

        <PrivateRoute
          path={RoutesPaths.registerManual}
          exact
          component={CadastrarManual}
        />
        <PrivateRoute
          path={RoutesPaths.listManual}
          exact
          component={ListarManual}
        />
        <PrivateRoute
          path={`${RoutesPaths.editManual}:id`}
          exact
          component={EditarManual}
        />
        <Route path={RoutesPaths.expired} exact component={SessionExpired} />
        <Route
          path={RoutesPaths.unauthorized}
          component={SessionUnauthorized}
        />
        <Route path={RoutesPaths.notFound} component={Session404} />
      </Switch>
    </AnimatePresence>
  );
};

class RoutesPaths {
  static dashboardCobranca = '/dashboard';
  static dashboardPagamentos = '/dashboard-pagamentos';
  static dashboardConvenios = '/dashboard-convenios';
  static login = '/login';
  static loginExterno = '/login-externo';
  static home = '/home';
  static expired = '/acesso/expirado';
  static unauthorized = '/acesso/negado';
  static motorCobranca = '/motor';
  static motorPagamentos = '/motor-pagamentos';
  static motorConvenios = '/motor-convenios';
  static notFound = '**';

  static listManual = '/manual/listar';
  static editManual = '/manual/editar/';
  static registerManual = '/manual/cadastrar';

  static listInstruction = '/instrucao/listar';
  static editInstruction = '/instrucao/editar/';
  static registerInstruction = '/instrucao/cadastrar';

  static listFAQ = '/pergunta/listar';
  static editFAQ = '/pergunta/editar/';
  static registerFAQ = '/pergunta/cadastrar';

  static listPerfil = '/perfil/listar';
  static editPerfil = '/perfil/editar/';
  static registerPerfil = '/perfil/cadastrar';

  static listScreen = '/telas/listar';
  static editScreen = '/telas/editar/';
  static registerScreen = '/telas/cadastrar';

  static listCriticalMessage = '/mensagens-criticas/listar';
  static editCriticalMessage = '/mensagens-criticas/editar/';
  static registerCriticalMessage = '/mensagens-criticas/cadastrar';
}
export { RoutesPaths };

export default Routes;
